var exports = {
  "nM": "row__nwLXHH",
  "Qs": "content__2CZlr8",
  "iU": "message__GcC33E",
  "mw": "messageRow__L_p5oc",
  "Tq": "bubble__RR-pLx",
  "Ft": "references__yraut1",
  "H": "avatarContainer__oo38YT",
};

module.exports = exports;
